import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';
import { makeNullable } from '../../utils/typeboxHelpers';

const equipmentFieldValueSchema = Type.Object({
    id: Type.String(),
    equipmentTypeFieldId: Type.String(),
    name: Type.String(),
    fieldOrder: Type.Integer(),
    value: makeNullable(Type.String()),
});

export const equipmentFieldValuePaths = {
    '/api/equipment/{equipmentId}/fieldValues': {
        parameters: [createPathGuidParameter('equipmentId')],
        get: {
            operationId: 'equipmentFieldValueControllers.getAll',
            responses: {
                '200': {
                    description: 'Array of field values for equipment',
                    content: {
                        'application/json': {
                            schema: Type.Object({ items: Type.Array(equipmentFieldValueSchema) }),
                        },
                    },
                },
            },
        },
        post: {
            operationId: 'equipmentFieldValueControllers.upsert',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            values: Type.Array(
                                Type.Object({
                                    equipmentTypeFieldId: Type.String(),
                                    value: makeNullable(Type.String()),
                                }),
                            ),
                        }),
                    },
                },
            },
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                ok: Type.Boolean(),
                            }),
                        },
                    },
                },
            },
        },
    },
} as const;
